// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-SchedActions-SchedActions-module__button--cbCl6 {
  width: 36px !important;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsScheduling/SchedulingControl/SchedulingTable/SchedTableToolbar/SchedActions/SchedActions.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF","sourcesContent":[".button {\n  width: 36px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-businessServices-services-bsScheduling-SchedulingControl-SchedulingTable-SchedTableToolbar-SchedActions-SchedActions-module__button--cbCl6`
};
export default ___CSS_LOADER_EXPORT___;
